(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[470],{

/***/ 7667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(5934);
;// CONCATENATED MODULE: ./src/components/Hero/Hero.tsx




function Hero(props) {
    var title = props.title, image = props.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        role: "banner",
        className: "hero",
        children: [
            image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hero__image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (0,url/* addBaseUrl */.gI)(image.meta.download_url),
                    alt: image.title,
                    layout: "responsive",
                    width: 1200,
                    height: 500,
                    objectFit: "cover",
                    priority: true
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "hero__title",
                children: title
            })
        ]
    });
}
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./src/components/Hero/index.tsx

/* harmony default export */ var components_Hero = (Hero_Hero);


/***/ }),

/***/ 9614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ basePageWrap; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/views/BasePage/BasePage.tsx



var defaultSeoProps = {};
function BasePage_BasePage(props) {
    var children = props.children, _seo = props.seo, seo = _seo === void 0 ? defaultSeoProps : _seo, title = props.title;
    var seoHtmlTitle = seo.seo_html_title, seoMetaDescription = seo.seo_meta_description, seoOgTitle = seo.seo_og_title, seoOgDescription = seo.seo_og_description, seoOgUrl = seo.seo_og_url, seoOgImage = seo.seo_og_image, seoOgType = seo.seo_og_type, seoTwitterTitle = seo.seo_twitter_title, seoTwitterDescription = seo.seo_twitter_description, seoTwitterUrl = seo.seo_twitter_url, seoTwitterImage = seo.seo_twitter_image, seoMetaRobots = seo.seo_meta_robots, canonicalLink = seo.canonicalLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: seoHtmlTitle !== null && seoHtmlTitle !== void 0 ? seoHtmlTitle : title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#da532c"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    }),
                    seoMetaDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: seoMetaDescription
                    }) : null,
                    seoOgTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: seoOgTitle
                    }) : null,
                    seoOgDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: seoOgDescription
                    }) : null,
                    seoOgUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: seoOgUrl
                    }) : null,
                    seoOgImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: seoOgImage
                    }) : null,
                    seoOgType ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: seoOgType
                    }) : null,
                    seoTwitterTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: seoTwitterTitle
                    }) : null,
                    seoTwitterDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: seoTwitterDescription
                    }) : null,
                    seoTwitterUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: seoTwitterUrl
                    }) : null,
                    seoTwitterImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: seoTwitterImage
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: seoMetaRobots
                    }),
                    canonicalLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalLink
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "base-page",
                children: children
            })
        ]
    });
}
/* harmony default export */ var views_BasePage_BasePage = (BasePage_BasePage);

;// CONCATENATED MODULE: ./src/views/BasePage/index.tsx





var basePageWrap = function(Component) {
    var WrappedBasePage = function WrappedBasePage(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_BasePage_BasePage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            _class: Component.name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props))
        }));
    };
    var _displayName, ref;
    var displayName = (ref = (_displayName = Component.displayName) !== null && _displayName !== void 0 ? _displayName : Component.name) !== null && ref !== void 0 ? ref : "Component";
    WrappedBasePage.displayName = "basePageWrap(".concat(displayName, ")");
    return WrappedBasePage;
};
/* harmony default export */ var views_BasePage = ((/* unused pure expression or super */ null && (BasePage)));


/***/ }),

/***/ 7470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_HomePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Hero/index.tsx + 1 modules
var Hero = __webpack_require__(7667);
// EXTERNAL MODULE: ./src/streamfields/Streamfields.tsx + 43 modules
var Streamfields = __webpack_require__(1550);
// EXTERNAL MODULE: ./src/views/BasePage/index.tsx + 1 modules
var BasePage = __webpack_require__(9614);
;// CONCATENATED MODULE: ./src/views/HomePage/HomePage.tsx





function HomePage(props) {
    var title = props.title, content = props.content, bannerImage = props.banner_image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "home-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                title: title,
                image: bannerImage
            }),
            content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Streamfields/* default */.Z, {
                fields: content
            }) : null
        ]
    });
}
/* harmony default export */ var HomePage_HomePage = ((0,BasePage/* basePageWrap */.P)(HomePage));

;// CONCATENATED MODULE: ./src/views/HomePage/index.tsx

/* harmony default export */ var views_HomePage = (HomePage_HomePage);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

}]);